/**
 *
 * Asynchronously loads the component for CompanyPoc
 *
 */

import { lazyLoad } from 'utils/loadable';

export const CompanyPoc = lazyLoad(
  () => import('./index'),
  module => module.CompanyPoc,
);
